<ng-container [ngSwitch]="status">
    <span pTooltip="Concluído" *ngSwitchCase="'paid'" class="success">
        <i class="pi pi-check"></i>
    </span>
    <span pTooltip="Estornado" *ngSwitchCase="'canceled'" class="error">
        <i class="pi pi-times"></i>
    </span>
    <span pTooltip="Pendente" *ngSwitchCase="'pending'" class="pending">
        <i class="pi pi-spinner"></i>
    </span>
    <span pTooltip="Concluído" *ngSwitchCase="'splitted'" class="success">
        <i class="pi pi-check"></i>
    </span>
</ng-container>